<template>
<b-card>
  <template #header>
    <h5 class="card-title">Layanan</h5>
  </template>
  <div class="d-flex align-items-center">
    <template v-if="showContent">
      <b-form-checkbox @change="$emit('updateShowSection', $event, 'home-service', apiGet)" id="preview" value="Y" unchecked-value="N" name="preview" v-model="showContent">Show Section?</b-form-checkbox>
    </template>

    <b-button variant="secondary" class="btn-rounded ml-auto" v-if="previewOpen" @click="closePreviewForm">
      Close <i class="fas fa-times ml-2"></i>
    </b-button>
    <b-button variant="outline-info" class="btn-rounded ml-auto" @click="showPreviewUpdate" v-else>
      Update Content <i class="fas fa-pencil-alt ml-2"></i>
    </b-button>

  </div>
  <hr />

  <validation-observer v-slot="{ handleSubmit }" ref="VFormDescription" tag="div" v-if="previewOpen">
    <b-form @submit.prevent="handleSubmit(doSubmitDesc)">
      <b-card class="border mb-0">
        <template #header>
          <h5 class="card-title">Content</h5>
        </template>
        <b-row class="mb-2">
          <b-col md=4>
            <div class="form-group">
              <label class="control-label">Title <span class="text-danger">*</span></label>
              <b-form-input v-model="row.asc_title" />
              <VValidate name="Title" v-model="row.asc_title" rules="required|min:3|max:160" />
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md=4>
            <div class="form-group">
              <label class="control-label">Description</label>
              <b-form-textarea :rows="3" v-model="row.asc_content" />
              <VValidate name="Description" v-model="row.asc_content" rules="min:3" />
            </div>
          </b-col>
        </b-row>
        <template #footer>
          <div class="text-right">
            <b-button variant="secondary" class="btn-rounded mr-3" @click="closePreviewForm">Cancel</b-button>
            <button type="submit" class="btn btn-info btn-rounded">Save Changes</button>
          </div>
        </template>
      </b-card>
    </b-form>
  </validation-observer>

  <template v-else>
    <div class="row justify-content-center">
      <div class="col-md-8 text-center">
        <h3>{{row.asc_title}}</h3>
        <div class="sect-heading__line"></div>
        <p>{{row.asc_content}}</p>
      </div>
    </div>

    <b-row>
      <b-col lg="6" v-for="(v, k) in service" :key="`service${k}`">
        <div class="wrap_service d-flex flex-column justify-content-center">
          <b-row>
            <b-col lg="6">
              <div class="thumb_service">
                <img :src="parent.uploader(v.image)" alt="" title="" class="loaded tns-complete">
                <div class="svg-container ">
                  <img src="https://lingkarhub.com/clients/mitra-pengadaan/ui/assets/images/card-triangle.svg" alt="" title="" class="loaded tns-complete">
                </div>
                <div class="svg-container-line ">
                  <img src="https://lingkarhub.com/clients/mitra-pengadaan/ui/assets/images/card-triangle-line.svg" alt="" title="" class="loaded tns-complete">
                </div>

                <div class="bullet-cta" style="left: 8px;">
                  <b-button type="button" @click="openModal('modalService', {...v, keyData: k})" variant="warning" class="btn-icon mr-0 rounded-pill" v-b-tooltip.hover title="Update Service">
                    <i class="ti-pencil"></i>
                  </b-button>
                  <b-button @click="doDelete(v)" type="button" variant="danger" class="btn-icon mt-1 mr-0 rounded-pill" v-b-tooltip.hover title="Delete Service">
                    <i class="ti-trash"></i>
                  </b-button>
                </div>
              </div>
            </b-col>
            <b-col lg="6">
              <div class="post_service">
                <h3 class="font-weight-bold">{{ v.title }}</h3>
                <span v-html="v.content"></span>

                <div class="company-preview-cta mt-2">
                  <a :href="v.button_link" class="cta cta--secondary cta--arrow">
                    {{v.button_label}}
                  </a>
                </div>
                
              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>

      <b-col lg="12" class="mt-3">
        <div class="text-center">
          <b-button variant="outline-primary" class="rounded-pill" @click="openModal('modalService')"><i class="ti-plus"></i> Add Service</b-button>
        </div>
      </b-col>
    </b-row>

    <b-modal id="modalService" :title="(serviceRow.typeLabel == 'Added' ? 'Add' : 'Update') + ' Service'" size="lg">
      <validation-observer v-slot="{ handleSubmit }" ref="VFormService">
        <b-form @submit.prevent="handleSubmit(doSubmit)">

          <b-row>
            <b-col md=5>
              <div class="form-group mb-2">
                <label class="control-label">Title <span class="text-danger">*</span></label>
                <input type="text" class="form-control" placeholder="Title" v-model="serviceRow.title">
                <VValidate name="Title" v-model="serviceRow.title" :rules="{required: true, min: 3, regex:/^[^\s]+(\s+[^\s]+)*$/}" />
              </div>

							<div class="form-group">
								<label class="control-label">Image <span class="text-danger">*</span></label>         
								<Uploader v-model="serviceRow.image" type="supply_category"/>
								<VValidate 
									name="Image" 
									v-model="serviceRow.image"
									:rules="{required: 1}" 
								/>
							</div>

						</b-col>
            <b-col md=7>
              <b-row>
                <b-col lg=6>
                  <div class="form-group mb-2">
                    <label class="control-label">Button Label <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" placeholder="Button Label" v-model="serviceRow.button_label">
                    <VValidate name="Button Label" v-model="serviceRow.button_label" :rules="{required: true, min: 3}" />
                  </div>
                </b-col>
                <b-col lg=6>
                  <div class="form-group mb-2">
                    <label class="control-label">Button Link <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" placeholder="Button Link" v-model="serviceRow.button_link">
                    <VValidate name="Button Link" v-model="serviceRow.button_link" :rules="{required: true, min: 3}" />
                  </div>
                </b-col>
              </b-row>
              <div class="form-group mb-2">
                <label class="control-label">Content <span class="text-danger">*</span></label>
                <CKEditor :value.sync="serviceRow.content" />

                <VValidate 
                  name="Content" 
                  v-model="serviceRow.content" 
                  :rules="{ required: 1, min: 3 }" 
                />
              </div>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <template #modal-footer="{close}">
        <div class="text-right">
          <b-button class="btn-rounded" variant="outline-secondary" @click="close">Cancel</b-button>
          <b-button type="button" @click="doSubmit" class="btn-rounded ml-2" variant="primary">Save Changes</b-button>

        </div>
      </template>
    </b-modal>
  </template>

</b-card>
</template>

<script>
import Gen from '@/libs/Gen.js'
import CKEditor from "@/components/CKEditor.vue"
// let _ = global._

export default {
  components: { CKEditor },
  props: {
    modulePage: String
  },
  data() {
    return {
      previewOpen: false,
      serviceRow: {},
      row: {},
      service: [],
      configCKEditor: ['heading', '|', 'bold', 'italic', 'underline', 'strikethrough', 'link', 'bulletedList', 'numberedList', 'blockQuote'],
      validation: {},
      showCompanyBrief: false,
      showContent: null
    }
  },
  computed: {
    parent() {
      return this.$parent.$parent.$parent
    }
  },
  mounted() {
    this.apiGet()
  },
  methods: {
    showPreviewUpdate() {
      this.previewOpen = true
    },
    closePreviewForm() {
      this.previewOpen = false
    },
    openModal(modal, data = null) {
      this.$bvModal.show(modal)

      this.$set(this, 'serviceRow', {
        typeLabel: 'Added'
      })
      if (data) this.$set(this, 'serviceRow', {
        ...this.serviceRow,
        ...data,
        typeLabel: 'Updated'
      })
    },
    doDelete(data){
      this.$swal.fire({
        title: "Do You Really Want to Delete This Data",
        text: "Data that has been deleted can't recover anymore.",
        icon: 'warning',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Yes, Delete Data",
        cancelButtonText: "No, Cancel",
      }).then(button => {
        if(button.isConfirmed){
          this.parent.swalLoading()
          let service = this.service.filter(dtService => dtService.title != data.title)

          Gen.apiRest('/do/' + this.modulePage, 
              { data: { type: 'updateService', ac_value: service, type_label: "Deleted" } }
            ).then(res => {
              if(res){
                this.$swal({
                  title: res.data.message,
                  icon: 'success',
                }).then(() => {
                  this.$bvModal.hide('modalService')
                  this.apiGet()
                })
              }
            }).catch(err => {
              this.$swal({title: err.response.data.message, icon:'error'})
            })
        }
      })
    },
    doSubmit() {
      this.$refs.VFormService.validate().then(success => {
        if (!success) return

        this.parent.swalLoading()
        let service

        if (!this.service.length) {
          service = [{
            ...this.serviceRow,
            typeLabel: null
          }]
        } else {
          if (this.serviceRow.typeLabel == "Updated") {
            service = this.service.map((dtService, kService) => {
              if (kService == this.serviceRow.keyData) return {
                ...this.serviceRow,
                keyData: null
              }
              return dtService
            })
          } else {
            service = [...this.service, {
              ...this.serviceRow,
              typeLabel: null
            }]
          }
        }

        Gen.apiRest('/do/' + this.modulePage, {
          data: {
            type: 'updateService',
            ac_value: service,
            type_label: this.serviceRow.typeLabel
          }
        }).then(res => {
          if (res) {
            this.$swal({
              title: res.data.message,
              icon: 'success',
            }).then(() => {
              this.$bvModal.hide('modalService')
              this.apiGet()
            })
          }
        }).catch(err => {
          this.$swal({
            title: err.response.data.message,
            icon: 'error'
          })
        })
      })
    },
    doSubmitDesc() {
      this.$refs.VFormDescription.validate().then(success => {
        if (!success) return

        this.parent.swalLoading()

        Gen.apiRest('/do/' + this.modulePage, {
          data: {
            type: 'updateServiceDescription',
            ...this.row
          }
        }).then(res => {
          if (res) {
            this.$swal({
              title: res.data.message,
              icon: 'success',
            }).then(() => {
              this.closePreviewForm()
              this.apiGet()
            })
          }
        }).catch(err => {
          this.$swal({
            title: err.response.data.message,
            icon: 'error'
          })
        })
      })
    },
    apiGet() {
      Gen.apiRest('/get/' + this.modulePage + '/service', {}, 'GET').then(res => {
        this.row = res.data.row
        this.service = res.data.service
        this.validation = res.data.validation
        this.showContent = res.data.showContent
      })
    }
  }
}
</script>
<style scoped>
.cta--arrow {
  padding-right: 56px !important;
}

.cta--secondary {
  background-color: #F7C832 !important;
  border-color: #F7C832 !important;
}

.cta {
  font-size: 12px !important;
  border-radius: 5px !important;
  text-transform: uppercase !important;
  padding: 10px 14px !important;
  border: 1px solid transparent !important;
  color: #000 !important;
  background-color: transparent;
  display: inline-block !important;
  font-weight: 622300 !important;
  font-weight: 700 !important;
  position: relative !important;
  transition: 0.25s ease-in-out !important;
}

.cta--arrow i {
  position: absolute !important;
  top: -1px !important;
  right: -1px !important;
  bottom: -1px !important;
  width: 40px !important;
  border-radius: 5px !important;
  background-color: rgba(0, 0, 0, .125) !important;
  display: block !important;
  text-align: center !important;
  line-height: 46px !important;
  font-size: 18px !important;
  transition: 0.25s ease-in-out !important;
}
</style>